/**
 * 分页壳 `PageResult` —— 契约 §7（D-2 订单、D-3 会话列表共用）。
 *
 * 后端 `com.cione.common.core.api.PageResult`：`{records, total, page, size}`。
 * ⚠ **只有会话「列表」和订单「列表」用 page/size**；会话「消息」用的是游标
 *   （`?before&limit`，返回裸数组），不是这个壳 —— 别把两者混成一个。
 */
import { z } from 'zod'

/**
 * 用一页 `item` 的 schema 包出 `PageResult<item>`。
 *
 * ⚠ 用 looseObject：后端往分页壳里加字段（如 `hasNext`）是允许的，挡下来就是自己找事。
 * ⚠ 三个计数字段给了默认值：真实响应它们一定在，但空列表这类边角上宁可容错也别整页解析失败。
 */
export function pageResultSchema<T extends z.ZodType>(item: T) {
  return z.looseObject({
    records: z.array(item),
    total: z.number().int().nonnegative().default(0),
    page: z.number().int().positive().default(1),
    size: z.number().int().nonnegative().default(20),
  })
}

/** `PageResult<T>` 的静态类型。⚠ 手写而不是 `z.infer`：泛型工厂的 infer 会把 `T` 丢成 unknown。 */
export interface PageResult<T> {
  records: T[]
  total: number
  page: number
  size: number
}
